"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const constants = __importStar(require("@/common/constants"));
const vueRoot_1 = require("@/client/components/vueRoot");
const utils_1 = require("@/common/utils/utils");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const SoundManager_1 = require("@/client/utils/SoundManager");
const Phase_1 = require("@/common/Phase");
const paths_1 = require("@/common/app/paths");
const statusCode_1 = require("@/common/http/statusCode");
const Types_1 = require("@/common/Types");
const AppErrorId_1 = require("@/common/app/AppErrorId");
let ui_update_timeout_id;
let documentTitleTimer;
const CANNOT_CONTACT_SERVER = 'Unable to reach the server. It may be restarting or down for maintenance.';
exports.default = (0, vue_1.defineComponent)({
    name: 'waiting-for',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        players: {
            type: Array,
            required: true,
        },
        settings: {
            type: Object,
            required: true,
        },
        waitingfor: {
            type: Object,
            default: undefined,
        },
    },
    data() {
        return {
            waitingForTimeout: this.settings.waitingForTimeout,
            playersWaitingFor: [],
            suspend: false,
            savedPlayerView: undefined,
        };
    },
    methods: {
        animateTitle() {
            if (!(0, PreferencesManager_1.getPreferences)().animated_title) {
                return;
            }
            const sequence = '\u25D1\u25D2\u25D0\u25D3';
            const first = document.title[0];
            const position = sequence.indexOf(first);
            let next = sequence[0];
            if (position !== -1 && position < sequence.length - 1) {
                next = sequence[position + 1];
            }
            const playerCount = this.playerView.players.length;
            const gameType = playerCount === 1 ? 'Solo Game' : `${playerCount} Player Game`;
            document.title = next + ' ' + `${gameType} | ${this.$t(constants.APP_NAME)}`;
        },
        onsave(out) {
            this.fetchPlayerInput(paths_1.paths.PLAYER_INPUT + '?id=' + this.playerView.id, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ runId: this.playerView.runId, ...out }),
            });
        },
        reset() {
            this.fetchPlayerInput(paths_1.paths.RESET + '?id=' + this.playerView.id, { method: 'GET' });
        },
        fetchPlayerInput(url, options) {
            const root = (0, vueRoot_1.vueRoot)(this);
            if (root.isServerSideRequestInProgress) {
                console.warn('Server request in progress');
                return;
            }
            root.isServerSideRequestInProgress = true;
            fetch(url, options)
                .then(async (response) => {
                if (response.ok) {
                    this.updatePlayerView(await response.json());
                    return;
                }
                const showAlert = (0, vueRoot_1.vueRoot)(this).showAlert;
                if (response.status === statusCode_1.statusCode.badRequest) {
                    const resp = await response.json();
                    let cb = () => { };
                    if (resp.id === AppErrorId_1.INVALID_RUN_ID) {
                        cb = () => setTimeout(() => window.location.reload(), 100);
                    }
                    showAlert('Error with input', resp.message, cb);
                }
                else {
                    showAlert('Error processing response', 'Unexpected response from server. Please try again.');
                    console.error(response.statusText);
                }
            })
                .catch((e) => {
                root.showAlert('Error sending input,', CANNOT_CONTACT_SERVER);
                console.error(e);
            })
                .finally(() => {
                root.isServerSideRequestInProgress = false;
            });
        },
        updatePlayerView(playerView) {
            if (this.suspend === false) {
                const root = (0, vueRoot_1.vueRoot)(this);
                root.screen = 'empty';
                root.playerView = playerView;
                root.playerkey++;
                root.screen = 'player-home';
                if (this.playerView.game.phase === 'end' && window.location.pathname !== paths_1.paths.THE_END) {
                    window.location = window.location;
                }
                this.savedPlayerView = undefined;
            }
            else {
                this.savedPlayerView = playerView;
            }
        },
        waitForUpdate() {
            const vueApp = this;
            const root = (0, vueRoot_1.vueRoot)(this);
            clearTimeout(ui_update_timeout_id);
            const askForUpdate = () => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', paths_1.paths.API_WAITING_FOR + window.location.search + '&gameAge=' + this.playerView.game.gameAge + '&undoCount=' + this.playerView.game.undoCount);
                xhr.onerror = function () {
                    root.showAlert('Error fetching state', CANNOT_CONTACT_SERVER, () => vueApp.waitForUpdate());
                };
                xhr.onload = () => {
                    if (xhr.status === statusCode_1.statusCode.ok) {
                        const result = xhr.response;
                        this.playersWaitingFor = result.waitingFor;
                        if (result.result === 'GO') {
                            root.updatePlayer();
                            this.notify();
                            return;
                        }
                        else if (result.result === 'REFRESH') {
                            if ((0, Types_1.isPlayerId)(this.playerView.id)) {
                                root.updatePlayer();
                            }
                            else {
                                root.updateSpectator();
                            }
                            return;
                        }
                        vueApp.waitForUpdate();
                    }
                    else {
                        root.showAlert('Error with input', `Received unexpected response from server (${xhr.status}). This is often due to the server restarting.`, () => vueApp.waitForUpdate());
                    }
                };
                xhr.responseType = 'json';
                xhr.send();
            };
            ui_update_timeout_id = window.setTimeout(askForUpdate, this.waitingForTimeout);
        },
        notify() {
            if ((0, PreferencesManager_1.getPreferences)().enable_sounds) {
                SoundManager_1.SoundManager.playActivePlayerSound();
            }
            if (Notification.permission !== 'granted') {
                Notification.requestPermission();
            }
            else if (Notification.permission === 'granted') {
                const notificationOptions = {
                    icon: 'favicon.ico',
                    body: 'It\'s your turn!',
                };
                const notificationTitle = constants.APP_NAME;
                try {
                    new Notification(notificationTitle, notificationOptions);
                }
                catch (e) {
                    if (!window.isSecureContext || !navigator.serviceWorker) {
                        return;
                    }
                    navigator.serviceWorker.ready.then((registration) => {
                        registration.showNotification(notificationTitle, notificationOptions);
                    }).catch((err) => {
                        console.warn('Failed to display notification with serviceWorker', err);
                    });
                }
            }
        },
        updateSuspend() {
            if (this.suspend === false && this.savedPlayerView !== undefined) {
                this.updatePlayerView(this.savedPlayerView);
            }
        },
        showRefresh() {
            return this.suspend === true && this.savedPlayerView !== undefined;
        },
    },
    mounted() {
        const playerCount = this.playerView.players.length;
        const gameType = playerCount === 1 ? 'Solo Game' : `${playerCount} Player Game`;
        document.title = `${gameType} | ${this.$t(constants.APP_NAME)}`;
        window.clearInterval(documentTitleTimer);
        if (this.waitingfor === undefined) {
            this.waitForUpdate();
        }
        if (this.playerView.players.length > 1 && this.waitingfor !== undefined) {
            documentTitleTimer = window.setInterval(() => this.animateTitle(), 1000);
        }
    },
    computed: {
        Phase() {
            return Phase_1.Phase;
        },
        preferences() {
            return PreferencesManager_1.getPreferences;
        },
        playerColorClass() {
            return utils_1.playerColorClass;
        },
    },
});
